export default __webpack_public_path__ + "static/media/3107.91800a63.png";